import {
  AimOutlined,
  CheckCircleOutlined,
  FallOutlined,
  RiseOutlined,
  StarFilled,
} from "@ant-design/icons";
import { Skeleton, Tooltip } from "antd";
import styles from "./AnalyticsPage.module.less";

const PASS_THRESHOLD = 60;

const KPICard = ({ icon, label, value, sub, color, tooltip }) => (
  <Tooltip title={tooltip} placement="top">
    <div className={styles.kpiCard} style={{ borderTopColor: color }}>
      <div className={styles.kpiIcon} style={{ color }}>
        {icon}
      </div>
      <div className={styles.kpiBody}>
        <div className={styles.kpiValue} style={{ color }}>
          {value}
        </div>
        <div className={styles.kpiLabel}>{label}</div>
        {sub && <div className={styles.kpiSub}>{sub}</div>}
      </div>
    </div>
  </Tooltip>
);

const AnalyticsKPIStrip = ({ kpis, isLoading, attributeLabel }) => {
  if (isLoading) {
    return (
      <div className={styles.kpiStrip}>
        {[...Array(5)].map((_, i) => (
          <div key={i} className={styles.kpiCard}>
            <Skeleton active paragraph={{ rows: 2 }} title={false} />
          </div>
        ))}
      </div>
    );
  }

  if (!kpis) return null;

  const {
    total,
    avgAccuracy,
    strongest,
    weakest,
    passingCount,
    totalQuestions,
  } = kpis;

  const passRate =
    total > 0 ? Math.round((passingCount / total) * 100) : 0;

  return (
    <div className={styles.kpiStrip}>
      <KPICard
        icon={<AimOutlined />}
        label={`Total ${attributeLabel}s`}
        value={total}
        sub={`${totalQuestions?.toLocaleString() ?? 0} questions`}
        color="#4b93ff"
        tooltip={`Number of distinct ${attributeLabel.toLowerCase()}s with recorded quiz activity`}
      />
      <KPICard
        icon={<StarFilled />}
        label="Avg Accuracy"
        value={`${avgAccuracy?.toFixed(1) ?? 0}%`}
        sub={avgAccuracy >= PASS_THRESHOLD ? "Above pass threshold" : "Below pass threshold"}
        color={avgAccuracy >= PASS_THRESHOLD ? "#16a34a" : "#ef4444"}
        tooltip="Average accuracy across all items in the selected period"
      />
      <KPICard
        icon={<RiseOutlined />}
        label="Strongest"
        value={`${strongest?.accuracy ?? 0}%`}
        sub={strongest?.name ?? "—"}
        color="#16a34a"
        tooltip={`Your best-performing ${attributeLabel.toLowerCase()} by average accuracy`}
      />
      <KPICard
        icon={<FallOutlined />}
        label="Weakest"
        value={`${weakest?.accuracy ?? 0}%`}
        sub={weakest?.name ?? "—"}
        color="#ef4444"
        tooltip={`Your worst-performing ${attributeLabel.toLowerCase()} — focus here to improve overall`}
      />
      <KPICard
        icon={<CheckCircleOutlined />}
        label="Pass Rate"
        value={`${passRate}%`}
        sub={`${passingCount} / ${total} passing`}
        color={passRate >= 60 ? "#16a34a" : "#d97706"}
        tooltip={`Percentage of ${attributeLabel.toLowerCase()}s where you scored ≥ ${PASS_THRESHOLD}%`}
      />
    </div>
  );
};

export default AnalyticsKPIStrip;
